import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";

import { Grid, Box, IconButton, Typography, Chip } from "@mui/material";

import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CheckIcon from "@mui/icons-material/Check";
import { IPlanSubscriptions } from "../ModalSubscriptions";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { UseFormAbandonment } from "../Hooks/UseFormAbandonment";
import { useEffect } from "react";

interface PlansSubscriptionsProps {
  setStep: (step: number) => void;
  planSelected: IPlanSubscriptions;
  setPlanSelected: (plan: IPlanSubscriptions) => void;
  listPlans: IPlanSubscriptions[];
}

export const PlansSubscriptions = ({
  setStep,
  planSelected,
  setPlanSelected,
  listPlans,
}: PlansSubscriptionsProps) => {
  const { handleSubmit } = UseFormAbandonment();

  useEffect(() => {
    handleSubmit({ event: "PLANS" });
  }, []);

  return (
    <Box sx={{ padding: { xs: "24px", md: "32px" } }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton
          onClick={() => setStep(1)}
          sx={{ color: "text.primary", mr: 1 }}
        >
          <ArrowBackIosNewIcon fontSize="small" sx={{ ml: "-3px" }} />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Escolha um plano
        </Typography>
      </Box>

      <Box id="plans">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 4,
            mb: 4,
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: "#e6f5ea",
              borderRadius: "50%",
              p: "6px",
              display: "inline-flex",
              mr: 2,
            }}
          >
            <CardGiftcardIcon
              sx={{ color: "#34a853", fontSize: { xs: "18px", md: "20px" } }}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "13px", md: "16px" },
            }}
          >
            Hoje! Teste gratuito de 10 dias. Cancele quando quiser.
          </Typography>
        </Box>

        <Grid container spacing={4} sx={{ mb: 3 }}>
          {listPlans.length ? (
            listPlans.map((plan, index) => (
              <Grid
                key={index}
                item
                xs={12}
                md={6}
                sx={{ height: "100%" }}
                onClick={() => setPlanSelected(plan)}
              >
                <Box
                  sx={{
                    position: "relative",
                    border:
                      planSelected?.title === plan?.title
                        ? "2px solid #8B3DFF"
                        : "2px solid #d6d6d6",
                    borderRadius: "8px",
                    height: "100%",
                    p: 3,
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#a46bfa",
                    },
                  }}
                >
                  {plan.recommended === true && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: -12,
                        left: "50%",
                        transform: "translateX(-50%)",
                        bgcolor: (theme) => theme.palette.primary.main,
                        color: "white",
                        borderRadius: "22px",
                        p: "4px 6px",
                        fontSize: "10px",
                      }}
                    >
                      Recomendado
                    </Box>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                      Plano {plan?.title}
                    </Typography>

                    <Typography variant="h6">
                      {FormatMoney(Math.round(plan.amount * 100))}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {plan.featuresCommon.map((feature) => (
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <CheckIcon sx={{ color: "#38c45b" }} />
                        <Typography variant="caption">{feature}</Typography>
                      </Box>
                    ))}

                    {plan.features?.map((feature) => (
                      <Box
                        key={feature}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <CheckIcon sx={{ color: "#38c45b" }} />
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 500,
                            fontSize: "13px",
                          }}
                        >
                          <Box>{feature}</Box>
                        </Typography>
                      </Box>
                    ))}
                    {plan.featuresPro?.map((feature) => (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box
                          key={feature}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <CheckIcon sx={{ color: "#38c45b" }} />
                          <Typography
                            variant="caption"
                            sx={{
                              fontWeight: 500,
                              fontSize: "13px",
                            }}
                          >
                            <Box>{feature}</Box>
                          </Typography>
                        </Box>
                        <Chip
                          label="Exclusivo"
                          size="small"
                          color="primary"
                          sx={{ fontSize: "10px" }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} sx={{ height: "100%" }}>
              <CardCore>
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  Nenhum plano disponível no momento.
                </Typography>
              </CardCore>
            </Grid>
          )}
        </Grid>

        <ButtonCore
          variant="contained"
          fullWidth
          sx={{
            bgcolor: "#8B3DFF",
            fontSize: "16px",
          }}
          title="Avançar"
          onClick={() => setStep(3)}
        />
      </Box>
    </Box>
  );
};
